module.exports = __webpack_public_path__ + "img/img6.0a6ed7b9.svg";